export default __webpack_public_path__ + "static/media/mana2g.fb38177c.svg";